import React from 'react';
import { Phone, FileText, Database, ChartBar, ArrowRight, ShieldCheck } from '@phosphor-icons/react';
const steps = [{
  n: '01',
  label: 'Discovery',
  title: 'Free 30-minute discovery call',
  desc: 'No cost, no obligation. We map exactly where the pressure is, what software you use, and what good looks like.',
  risk: 'You leave the call with clarity, even if you do not engage Knight.',
  icon: Phone
}, {
  n: '02',
  label: 'Proposal',
  title: 'Fixed-fee proposal in writing',
  desc: 'Within 48 hours you receive a scoped proposal. You see exactly what you pay, what is included, and what is not.',
  risk: 'No surprises, no startup fees, no lock-in.',
  icon: FileText
}, {
  n: '03',
  label: 'Onboarding',
  title: 'Onboarding inside your existing software',
  desc: 'We slot into Xero, MYOB or QuickBooks. Secure handover from your current bookkeeper or internal team, run in parallel where it makes sense.',
  risk: 'Essential Eight-aligned. No data loss. No software switch.',
  icon: Database
}, {
  n: '04',
  label: 'Delivery',
  title: 'Ongoing delivery and CFO-level reporting',
  desc: 'Books on time every month, payroll on time every cycle, BAS lodged, and a monthly report you can actually act on. One named contact who knows your business.',
  risk: 'You stay in control. Cancel anytime, no penalty.',
  icon: ChartBar
}];
export function CustomerJourney() {
  return <section id="journey" className="py-16 lg:py-24 bg-off-white" data-id="element-57">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <div className="text-center max-w-3xl mx-auto mb-14" data-id="element-59">
          <p className="font-mono text-[11px] tracking-wider uppercase text-knight-orange mb-3" data-id="element-60">
            How working with Knight actually goes
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal leading-tight mb-4" data-id="element-61">
            Four steps. Each one designed to de-risk the next.
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-62">
            Switching bookkeepers, or moving from in-house to outsourced, is
            something we do every week. We manage the handover so your business
            keeps running.
          </p>
        </div>

        <div className="relative max-w-7xl mx-auto mb-14" data-id="element-63">
          <div className="hidden lg:block absolute top-7 left-[12%] right-[12%] h-px bg-hairline" data-id="element-64"></div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-5" data-id="element-65">
            {steps.map((step, i) => <div key={i} className="relative bg-white rounded-md border border-hairline p-7 flex flex-col" data-id="element-66">
                <div className="flex items-center gap-3 mb-5" data-id="element-67">
                  <div className="w-14 h-14 rounded-full bg-knight-orange text-white flex items-center justify-center font-mono font-semibold text-base ring-4 ring-off-white relative z-10" data-id="element-68">
                    {step.n}
                  </div>
                  <div data-id="element-69">
                    <div className="font-mono text-[10px] uppercase tracking-wider text-knight-orange" data-id="element-70">
                      {step.label}
                    </div>
                  </div>
                </div>
                <div className="w-10 h-10 rounded-md bg-off-white border border-hairline flex items-center justify-center mb-4" data-id="element-71">
                  <step.icon size={20} weight="duotone" className="text-charcoal" data-id="element-72" />
                </div>
                <h3 className="text-lg font-heading font-bold text-charcoal mb-2.5 leading-snug" data-id="element-73">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow" data-id="element-74">
                  {step.desc}
                </p>
                <div className="border-t border-hairline pt-3 flex items-start gap-2" data-id="element-75">
                  <ShieldCheck size={14} weight="duotone" className="text-knight-orange flex-shrink-0 mt-0.5" data-id="element-76" />
                  <p className="font-mono text-[11px] text-charcoal leading-relaxed" data-id="element-77">
                    {step.risk}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-near-black text-white rounded-md p-8 lg:p-10 text-center relative overflow-hidden" data-id="element-78">
          <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-79"></div>
          <div className="relative z-10" data-id="element-80">
            <p className="font-mono text-[10px] uppercase tracking-wider text-knight-orange mb-3" data-id="element-81">
              Honest scarcity
            </p>
            <h3 className="text-xl lg:text-2xl font-heading font-bold mb-3" data-id="element-82">
              We take on a small number of new clients each month.
            </h3>
            <p className="text-gray-400 leading-relaxed mb-6 max-w-xl mx-auto text-[15px]" data-id="element-83">
              So service stays personal and supervision stays real. If you are
              weighing it up, the consultation costs you nothing and tells you
              whether we are the right fit.
            </p>
            <a href="#lead" className="inline-flex items-center px-7 py-3.5 bg-knight-orange text-white font-semibold rounded-md hover:bg-knight-orange-hover transition-colors duration-300 ease-out-expo" data-id="element-84">
              Start with a consultation
              <ArrowRight size={16} weight="regular" className="ml-2" data-id="element-85" />
            </a>
            <p className="font-mono text-[10px] tracking-wide text-gray-500 uppercase mt-4" data-id="element-86">
              Free / No obligation / Reply in under 4 hours
            </p>
          </div>
        </div>
      </div>
    </section>;
}